export const getReactAppVersion = (data) => { 
    if (!data) return null
    const regex = /window\.REACT_APP_VERSION\s*=\s*'([^']+)'/
    const match = data.match(regex)
    const reactAppVersion = match ? match[1] : null
    
    return reactAppVersion
}